<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  data() {
    return {
      arrayFields: ['sections'],
      sectionItemOptions: [
        {
          label: 'Telefon',
          value: 'tel'
        },
        {
          label: 'E-mail',
          value: 'mailto'
        }
      ]
    }
  },
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'Tytuł',
              modelPath: [this, 'form', 'title'],
              multilingual: true
            }),
            new fields.ColorSelect({
              label: 'Kolor (domyślnie Podstawowy)',
              modelPath: [this, 'form', 'color']
            }),
            new fields.Header({
              type: 'h3',
              text: 'Sekcje'
            }),
            this.getSectionFormset()
          ]
        }
      ]
    }
  },
  methods: {
    getSectionFormset() {
      return new fields.Formset({
        modelPath: [this, 'form', 'sections'],
        blankObject: { items: [] },
        items: this.form.sections.map((itemSection, indexSection) => {
          return {
            headerLabel: itemSection.title_pl,
            fields: [
              new fields.Input({
                label: 'Tytuł',
                // prettier-ignore
                modelPath: [this, 'form', 'sections', indexSection, 'title'],
                multilingual: true,
                required: true
              }),
              new fields.Header({
                type: 'h4',
                text: 'Wartości'
              }),
              this.getSectionItemFormset(itemSection, indexSection)
            ]
          }
        })
      })
    },
    getSectionItemFormset(itemSection, indexSection) {
      return new fields.Formset({
        modelPath: [this, 'form', 'sections', indexSection, 'items'],
        items: itemSection.items.map((itemSectionItem, indexSectionItem) => {
          return {
            headerLabel: itemSectionItem.content,
            fields: [
              new fields.Select({
                label: 'Typ',
                // prettier-ignore
                modelPath: [this, 'form', 'sections', indexSection, 'items', indexSectionItem, 'type'],
                required: true,
                options: this.sectionItemOptions
              }),
              new fields.Input({
                label: 'Wartość',
                // prettier-ignore
                modelPath: [this, 'form', 'sections', indexSection, 'items', indexSectionItem, 'content'],
                required: true
              })
            ]
          }
        })
      })
    }
  }
}
</script>
